export const x = "x";
export const o = "o";
export const _ = "_";

export type Values = string[];

export interface Game {
    id: number;

    player: string;
    last: string;
    next: string;
    values: Values;

    waiting: boolean,
    finished: boolean;
    stale: boolean;
    won: boolean;
    winner: string;
    loser: string;
    horizontal: number;
    vertical: number;
    cross: number;
}
